import { render } from "./GiftAssignView.vue?vue&type=template&id=3524fac3"
import script from "./GiftAssignView.vue?vue&type=script&lang=js"
export * from "./GiftAssignView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__